module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img62.53318b66.jpg";